<template>
  <v-flex xs12 sm10 md8 lg7>
    <v-card class="mt-5">
      <v-card-title primary-title>
        <div class="headline">Contraseña</div>
      </v-card-title>
      <v-card-text>
        <v-layout row justify-space-around wrap>
          <v-flex xs12 sm10>
            <v-alert error v-model="alert">{{ alertMessage }}</v-alert>
          </v-flex>
        </v-layout>
        <v-layout row justify-space-around wrap>
          <v-flex xs12 sm8>
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="Contraseña anterior"
                :counter="24"
                v-model="oldPassword"
                :rules="passwordRules"
                type="password"
                required
              ></v-text-field>
              <v-text-field
                label="Contraseña nueva"
                :counter="24"
                v-model="newPassword"
                :rules="passwordRules"
                type="password"
                required
              ></v-text-field>
              <v-text-field
                label="Confirmar contraseña nueva"
                :counter="24"
                v-model="confirmPassword"
                :rules="confirmPasswordRules"
                type="password"
                required
              ></v-text-field>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="clear">Limpiar</v-btn>
        <v-btn
          flat
          success
          @click="submit"
          :loading="loading"
          :disabled="loading"
        >Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'password',
  props: {
    loading: Boolean
  },
  data: function () {
    return {
      alert: false,
      alertMessage: '',
      valid: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordRules: [
        (value) => !!value || 'Campo requerido',
        (value) => (value && value.length <= 24) || 'La contraseña debe contener menos de 24 caracteres',
        (value) => /^[a-zA-Z0-9_.-]+$/.test(value) || 'Contraseña inválida'
      ],
      confirmPasswordRules: [
        (value) => value === this.newPassword || 'Las contraseñas no coinciden'
      ]
    }
  },
  methods: {
    submit: function () {
      const form = this.$refs.form
      if (form.validate()) {
        this.$emit('update-password', {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        })
        this.alert = false
        form.reset()
      }
    },
    clear: function () {
      const form = this.$refs.form
      this.alert = false
      form.reset()
    },
    openAlert: function (message) {
      this.alertMessage = message
      this.alert = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile/Password.vue